module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pxii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents.htm#ch0d"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("Many languages were spoken along the Thailand–Burma Railway including English, Dutch and Japanese. As a result place names often have a variety of spellings, indicating a foreigner’s attempt to pronounce a Thai word phonetically.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In most instances I have adopted the form commonly used by historians of the railway, for example, Ban Pong, Chungkai, Hintok, Nakhon Pathom, Nong Pladuk, Tarsao, Wampo.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5169d93b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Authors_Note.vue
// module id = 69
// module chunks = 0